import React, { useState } from "react"
// react phone input
import "react-phone-input-2/lib/style.css"
import { ConfirmPasswordInput, InputWithLabel } from "@components/Form"
// assets
import { EyeIcon } from "@assets/icons/Eye.tsx"
import { EyeOffIcon } from "@assets/icons/EyeOff"

// assets

export const CreatePassword = ({ watch, control, errors }) => {
  const [showPassword, setShowPassword] = useState(false)

  const handleShowPassword = () => setShowPassword(!showPassword)

  const TogglePasswordIcon = ({ isVisible, toggleVisibility }) => {
    const Icon = isVisible ? EyeIcon : EyeOffIcon
    return (
      <Icon
        className="absolute right-3.5 h-5 w-5 text-[var(--text-secondary)] hover:cursor-pointer"
        onClick={toggleVisibility}
      />
    )
  }

  const passwordRules = {
    required: "Password is required",
    minLength: {
      value: 6,
      message: "Password must be at least 6 characters",
    },
    maxLength: {
      value: 50,
      message: "Password must be at most 50 characters",
    },
  }

  const password = watch("password")
  const repeatPassword = watch("repeatPassword")

  return (
    <>
      <div className="w-full md:max-w-[20.12rem] gap-4 flex flex-col bg-[--pure-white] p-4 md:p-0 rounded-2xl border border-[--border-theme-300] md:border-0">
        <h2 className="text-xs font-medium text-[--text-light-gray]">
          CREATE PASSWORD
        </h2>
        <InputWithLabel
          label="Password"
          name="password"
          rules={passwordRules}
          type={showPassword ? "text" : "password"}
          icon={
            <TogglePasswordIcon
              isVisible={showPassword}
              toggleVisibility={() => handleShowPassword()}
            />
          }
          placeholder="must be 6 characters or more"
          inputClassName="!pr-10"
          control={control}
          errors={errors}
          isRequired
        />
        {/* Confirm Password */}
        <ConfirmPasswordInput
          password={password}
          repeatPassword={repeatPassword}
          label="Confirm Password"
          name="repeatPassword"
          rules={passwordRules}
          type={showPassword ? "text" : "password"}
          icon={
            <TogglePasswordIcon
              isVisible={showPassword}
              toggleVisibility={() => handleShowPassword()}
            />
          }
          placeholder="repeat password"
          inputClassName="!pr-10"
          control={control}
          errors={errors}
          isRequired
        />
      </div>
    </>
  )
}

export default CreatePassword
